import {useEffect, useState} from "react";

// Api
import {GetVideosBySeries} from "../../../../Api/Video";

// Models
import VideoDTO from "../../../../Models/DTOs/VideoDTO";
import ICarouselContentDTO from "../../../../Models/DTOs/ICarouselContentDTO";

// Helpers
import {transformVideoToCarouselContent} from "../../../../Helpers/DataConversion/ConvertToCarouselContentItem";

function useFetchVideosBySeries(
    seriesId: number | string | null,
    take: number = 20,
    skip: number = 0,
    order: string = "releaseDateDesc",
    publishedOnly: boolean = true
) {
    const
        [content, setContent] = useState<ICarouselContentDTO[]>([]),
        [count, setCount] = useState<number>(0),
        [loading, setLoading] = useState<boolean>(false),
        [error, setError] = useState<string>("");

    useEffect(() => {
        let isCancelled = false;

        if (seriesId === null || seriesId === "" || seriesId === undefined) {
            setContent([]);
            setCount(0);
            setError("");
            setLoading(false);
            return () => {
                isCancelled = true;
            };
        }

        setLoading(true);
        setError("");

        (async () => {
            try {
                const data = await GetVideosBySeries({ seriesId, take, skip, order, publishedOnly });

                if (!isCancelled) {
                    const items: VideoDTO[] = data.items ?? [];

                    // dedupe by Video Id first
                    const uniqueVideos = items.filter(
                        (item: VideoDTO, index: number, self: VideoDTO[]) =>
                            index === self.findIndex((t) => t.Id === item.Id)
                    );

                    // transform to carousel content DTOs
                    const transformed = uniqueVideos.map(transformVideoToCarouselContent);

                    setContent(transformed);
                    setCount(data.count ?? uniqueVideos.length);
                }
            } catch (err) {
                if (!isCancelled) {
                    setError("Failed to fetch videos by series.");
                    console.error(err);
                }
            } finally {
                if (!isCancelled) setLoading(false);
            }
        })();

        return () => {
            isCancelled = true;
        };
    }, [seriesId, take, skip, order, publishedOnly]);

    return { content, count, loading, error };
}

export default useFetchVideosBySeries;
